import React, { useState } from 'react';
import { Suspense, lazy } from 'react';
import { Link } from 'react-router-dom';

const Activities = lazy(() => import('../Activities'));
const MeetingsCalendar = lazy(() => import('../MeetingsCalendar'));

type ViewMode = 'feed' | 'calendar';

const ActivitiesTab: React.FC = () => {
  const [viewMode, setViewMode] = useState<ViewMode>('feed');

  return (
    <div className="space-y-6">
      {/* View Switcher */}
      <div className="flex flex-wrap items-center gap-3">
        <div className="flex items-center gap-2 rounded-lg border border-gray-200 bg-white p-1 w-fit">
        <button
          onClick={() => setViewMode('feed')}
          className={`rounded px-4 py-2 text-sm font-medium transition ${
            viewMode === 'feed' ? 'bg-primary text-white' : 'text-gray-700 hover:bg-gray-100'
          }`}
        >
          📋 Activity Feed
        </button>
        <button
          onClick={() => setViewMode('calendar')}
          className={`rounded px-4 py-2 text-sm font-medium transition ${
            viewMode === 'calendar' ? 'bg-primary text-white' : 'text-gray-700 hover:bg-gray-100'
          }`}
        >
          📅 Calendar
        </button>
        </div>
        <Link
          to="/help?article=crm-activities"
          className="inline-flex items-center gap-2 rounded-lg border border-gray-200 bg-white px-3 py-2 text-xs font-semibold text-gray-600 shadow-sm transition hover:bg-gray-50"
        >
          ❓ Activities help
        </Link>
      </div>

      {/* Content */}
      {viewMode === 'feed' ? (
        <Suspense
          fallback={
            <div className="flex items-center justify-center rounded-xl bg-white p-10 shadow-sm ring-1 ring-gray-100">
              <div className="text-gray-500">Loading activities...</div>
            </div>
          }
        >
          <Activities />
        </Suspense>
      ) : (
        <Suspense
          fallback={
            <div className="flex items-center justify-center rounded-xl bg-white p-10 shadow-sm ring-1 ring-gray-100">
              <div className="text-gray-500">Loading calendar...</div>
            </div>
          }
        >
          <MeetingsCalendar />
        </Suspense>
      )}
    </div>
  );
};

export default ActivitiesTab;
